export default __webpack_public_path__ + "static/samosa-f08c36849b42f5c3860021918bfcae39.png";